import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip token for login endpoint
    if (req.url.includes('/auth/login')) {
      return next.handle(req);
    }

    const token = localStorage.getItem('authToken');

    // The store/warehouse selected in the header switcher travels with every
    // request so the backend scopes numbering (PO/GRN/TO/...), lists and
    // channel behavior to the SELECTED store instead of guessing
    // warehouse-first from the user's access rows.
    const activeStoreId = localStorage.getItem('storeId');
    const activeLocationId = localStorage.getItem('activeLocationId');

    // Super admin working inside a workspace: the backend honours this header
    // for SUPER_ADMIN only and scopes every query to that tenant.
    const tenantId = this.authService.getSelectedTenantId();

    const headers: { [name: string]: string } = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;
    if (activeStoreId) headers['x-active-store-id'] = activeStoreId;
    if (activeLocationId) headers['x-active-location-id'] = activeLocationId;
    if (tenantId) headers['x-tenant-id'] = tenantId;

    const authReq = Object.keys(headers).length
      ? req.clone({ setHeaders: headers })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Clear auth data
          localStorage.removeItem('authToken');
          this.authService.logout(); // Optional: if logout logic is centralized
          this.router.navigate(['']);
        }
        return throwError(() => error);
      })
    );
  }
}
